import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import theme from './AccessibilityShortcuts.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
};

const AccessibilityShortcuts = ({ intl }) => {
  const openAccMenuAction = () => {
    document.getElementById('open-accessibility-options-button')?.click();
  };

  return (
    <div className={ theme.root } >
      <div role="alert" tabIndex={ 0 }>
        { intl.formatMessage({
          id: 'WEB.Accessibility.Shortcuts.Title',
          defaultMessage: '** Accessibility button is at the bottom of the page. Use shortcuts below for quick navigation',
        }) }
      </div>
      <div>
        <button
          onClick={ openAccMenuAction }
          aria-label={ intl.formatMessage({ id: 'WEB.Accessibility.Shortcuts.GoToMenu', defaultMessage: '** Click to navigate accessibility menu' }) }
        >
          { intl.formatMessage({
            id: 'WEB.Accessibility.Shortcuts.GoToMenu',
            defaultMessage: '** Click to navigate accessibility menu' }) }
        </button>
      </div>
    </div>
  );
};

AccessibilityShortcuts.propTypes = propTypes;

export default injectIntl(AccessibilityShortcuts);
